<template>
  <div class="page-wrapper phieucong-page">
    <div class="content container-fluid pb-mobile-nav">
      <!-- HEADER (Desktop/Tablet) -->
      <div class="d-none d-md-flex justify-content-between align-items-center mb-3">
        <div>
          <h3 class="mb-1">
            <i class="fa fa-id-card text-primary mr-2"></i>
            Phiếu công & Phiếu lương (Cá nhân)
          </h3>
          <div class="text-muted small">
            Lưới công (mở phiếu) → Xác nhận công → Lương (Admin gửi) → PDF
          </div>
        </div>

        <div class="d-flex align-items-center">
          <input
            :value="monthInputValue"
            @change="onPickMonth"
            type="month"
            class="form-control mr-2"
            style="width: 170px"
          />
          <button class="btn btn-outline-secondary" @click="reloadAll" :disabled="loadingAny">
            <i class="fa fa-refresh mr-1"></i> Tải lại
          </button>
        </div>
      </div>

      <!-- MOBILE TOPBAR -->
      <div class="d-md-none mobile-topbar shadow-sm">
        <div class="d-flex align-items-center justify-content-between">
          <div class="font-weight-bold">
            <i class="fa fa-id-card text-primary mr-2"></i>Phiếu công
          </div>
          <div class="d-flex align-items-center">
            <input
              :value="monthInputValue"
              @change="onPickMonth"
              type="month"
              class="form-control form-control-sm mr-2"
              style="width: 140px"
            />
            <button class="btn btn-sm btn-outline-secondary" @click="reloadAll" :disabled="loadingAny">
              <i class="fa fa-refresh"></i>
            </button>
          </div>
        </div>

        <div class="mt-2 small text-muted">
          <div class="d-flex justify-content-between">
            <div><span class="badge badge-light mr-1">Tháng</span> {{ mmLabel }}</div>
            <div class="text-right">
              <span class="badge" :class="canViewGrid ? 'badge-primary' : 'badge-secondary'">
                {{ canViewGrid ? "Đã mở phiếu" : "Chưa mở" }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- ALERT -->
      <div v-if="errMsg" class="alert alert-danger mt-3">
        <i class="fa fa-warning mr-1"></i> {{ errMsg }}
      </div>

      <!-- WORKFLOW STATUS BAR -->
      <div class="card shadow-sm mt-3">
        <div class="card-body d-flex flex-wrap align-items-center gap-2">
          <div class="mr-2 font-weight-bold">
            <i class="fa fa-flag text-warning mr-1"></i> Trạng thái:
          </div>

          <span class="badge" :class="wf.congThangNay ? 'badge-primary' : 'badge-secondary'">
            {{ wf.congThangNay ? "Đã mở phiếu công" : "Chưa mở phiếu công" }}
          </span>

          <span class="badge" :class="wf.userConfirmed ? 'badge-success' : 'badge-warning'">
            {{ wf.userConfirmed ? "Bạn đã xác nhận công" : "Chưa xác nhận công" }}
          </span>

          <span class="badge" :class="wf.luongDaGui ? 'badge-info' : 'badge-secondary'">
            {{ wf.luongDaGui ? "Đã gửi phiếu lương" : "Chưa gửi phiếu lương" }}
          </span>

          <div class="ml-auto d-flex gap-2">
            <button class="btn btn-outline-secondary btn-sm" @click="reloadAll" :disabled="loadingAny">
              <i class="fa fa-refresh mr-1"></i> Cập nhật
            </button>

            <button
              v-if="canViewGrid"
              class="btn btn-outline-primary btn-sm"
              @click="activeTab = 'grid'"
              :disabled="loadingAny"
            >
              <i class="fa fa-calendar mr-1"></i> Lưới công
            </button>

            <button
              v-if="canViewGrid"
              class="btn btn-outline-primary btn-sm"
              @click="activeTab = 'overview'"
              :disabled="loadingAny"
            >
              <i class="fa fa-home mr-1"></i> Tổng quan
            </button>

            <button
              v-if="canViewGrid"
              class="btn btn-outline-danger btn-sm"
              @click="activeTab = 'pdf'"
              :disabled="loadingAny"
            >
              <i class="fa fa-file-pdf-o mr-1"></i> PDF
            </button>
          </div>
        </div>
      </div>

      <!-- LOCK SCREEN WHEN NOT PUBLISHED -->
      <div v-if="!canViewGrid" class="card shadow-sm mt-3">
        <div class="card-body text-center py-5">
          <div class="mb-2">
            <i class="fa fa-lock text-muted" style="font-size: 42px"></i>
          </div>
          <div class="h5 mb-2">Tháng này chưa được mở phiếu công</div>
          <div class="text-muted mb-3">
            Admin “Gửi phiếu công toàn bộ” thì bạn mới xem được lưới công.
          </div>
          <button class="btn btn-outline-secondary" @click="reloadAll" :disabled="loadingAny">
            <i class="fa fa-refresh mr-1"></i> Thử tải lại
          </button>
        </div>
      </div>

      <!-- ====== TAB: GRID (DEFAULT) ====== -->
      <div v-else v-show="activeTab === 'grid'" class="mt-3">
        <!-- KPI GRID SUMMARY (từ month-grid) -->
        <div class="row">
          <div class="col-md-3 col-6 mb-3">
            <div class="card shadow-sm h-100 kpi-card">
              <div class="card-body">
                <div class="text-muted small">Tổng công</div>
                <div class="h4 mb-0">{{ fmt(gridTotalCong) }}</div>
                <div class="text-muted small mt-1">Mode: {{ myRow?.chamCongMode || "-" }}</div>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-6 mb-3">
            <div class="card shadow-sm h-100 kpi-card">
              <div class="card-body">
                <div class="text-muted small">Đi trễ (phút)</div>
                <div class="h4 mb-0">{{ fmt(gridMinutesVaoTre) }}</div>
                <div class="text-muted small mt-1">
                  Vào sớm: {{ fmt(gridMinutesVaoSom) }} | Ra sớm: {{ fmt(gridMinutesRaSom) }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-6 mb-3">
            <div class="card shadow-sm h-100 kpi-card">
              <div class="card-body">
                <div class="text-muted small">Quên chấm</div>
                <div class="h4 mb-0">{{ fmt(gridQuenCham) }}</div>
                <div class="text-muted small mt-1">
                  Nghỉ phép: {{ fmt(gridNghiPhepFull) }} (Full) | {{ fmt(gridNghiPhepAm) }} (AM) |
                  {{ fmt(gridNghiPhepPm) }} (PM)
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-6 mb-3">
            <div class="card shadow-sm h-100 kpi-card">
              <div class="card-body">
                <div class="text-muted small">Lệnh hoàn thành</div>
                <div class="h4 mb-0">{{ fmt(gridLenhHoanThanh) }}</div>
                <div class="text-muted small mt-1">Tổng ngày: {{ fmt(myMonth?.daysInMonth) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- GRID TABLE -->
        <div class="card shadow-sm">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="font-weight-bold">
              <i class="fa fa-calendar text-success mr-2"></i> Lưới công tháng
            </div>
            <div class="d-flex align-items-center">
              <button class="btn btn-sm btn-outline-secondary mr-2" @click="prevMonth" :disabled="mm.loading">
                <i class="fa fa-chevron-left"></i>
              </button>
              <div class="small text-muted">{{ mmLabel }}</div>
              <button class="btn btn-sm btn-outline-secondary ml-2" @click="nextMonth" :disabled="mm.loading">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <div v-if="mm.loading" class="p-3 text-muted">
            <i class="fa fa-spinner fa-spin mr-1"></i> Đang tải lưới tháng...
          </div>

          <div v-else>
            <!-- Mobile -->
            <div class="d-md-none p-2">
              <div v-if="!myRow?.daily?.length" class="text-center text-muted py-4">
                Không có dữ liệu lưới.
              </div>

              <div v-else>
                <div
                  v-for="c in myRow.daily"
                  :key="c.day"
                  class="day-card border rounded p-2 mb-2"
                  :class="{
                    'day-card--sun': c.sunday,
                    'day-card--holiday': c.holiday,
                    'day-card--leave': c.coNghiPhep
                  }"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="font-weight-bold">
                      Ngày {{ c.day }}
                      <span v-if="c.sunday" class="badge badge-secondary ml-1">CN</span>
                      <span v-if="c.holiday" class="badge badge-danger ml-1">Lễ</span>
                      <span v-if="c.coNghiPhep" class="badge badge-info ml-1">Phép</span>
                    </div>
                    <div class="text-right">
                      <div class="small text-muted">Công</div>
                      <div class="font-weight-bold">{{ fmt(c.soCong) }}</div>
                    </div>
                  </div>

                  <div class="d-flex flex-wrap mt-2 small">
                    <div class="mr-3">
                      <span class="text-muted">Sáng:</span> <b>{{ congText(c.soCongAm, "Sáng") }}</b>
                    </div>
                    <div class="mr-3">
                      <span class="text-muted">Chiều:</span> <b>{{ congText(c.soCongPm, "Chiều") }}</b>
                    </div>
                    <div class="mr-3">
                      <span class="text-muted">Trễ:</span> <b>{{ fmt(c.tongVaoTre) }}</b>p
                    </div>
                    <div class="mr-3">
                      <span class="text-muted">Quên:</span>
                      <b :class="c.tongQuenCham > 0 ? 'text-danger' : ''">{{ fmt(c.tongQuenCham) }}</b>
                    </div>
                    <div class="mr-3">
                      <span class="text-muted">Lệnh:</span> <b>{{ fmt(c.soLenhHoanThanh) }}</b>
                    </div>
                  </div>

                  <div class="mt-2">
                    <span class="badge badge-pill" :class="statusBadge(c.status)">
                      {{ statusText(c.status) }}
                    </span>
                  </div>

                  <!-- ✅ LENH LINES (Tăng ca / Chủ nhật) - ĐẶT TRONG SCOPE c -->
                  <div class="mt-2" v-if="lenhByDay[dayKeyFromCell(c)]?.length">
                    <div
                      v-for="l in lenhByDay[dayKeyFromCell(c)]"
                      :key="l.idLenh"
                      class="lenh-line d-flex align-items-center justify-content-between border rounded px-2 py-1 mb-1"
                    >
                      <div class="d-flex align-items-center">
                        <span :class="lenhBadgeClass(l.loaiLenh)" class="mr-2">
                          {{ l.loaiLenh === 'TANG_CA' ? 'TC' : (l.loaiLenh === 'CHU_NHAT' ? 'CN' : 'L') }}
                        </span>

                        <div class="small">
                          <div class="font-weight-semibold">
                            {{ lenhLabel(l.loaiLenh) }}:
                            {{ fmtTime(l.chamCong?.gioVao || l.batDau) }} → {{ fmtTime(l.chamCong?.gioRa || l.ketThuc) }}
                          </div>
                          <div class="text-muted">
                            {{ Number(l.chamCong?.soGioThuong || 0).toFixed(2) }}h • {{ fmtMoney(l.chamCong?.soTienThuong) }}đ
                          </div>
                        </div>
                      </div>

                      <div class="text-right small text-muted">#{{ l.idLenh }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Desktop -->
            <div class="d-none d-md-block table-responsive">
              <table class="table table-sm table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 70px">Ngày</th>
                    <th>Trạng thái</th>
                    <th class="text-right">Công</th>
                    <th class="text-right">AM</th>
                    <th class="text-right">PM</th>
                    <th class="text-right">Trễ</th>
                    <th class="text-right">Vào sớm</th>
                    <th class="text-right">Ra sớm</th>
                    <th class="text-right">Quên</th>
                    <th class="text-right">Lệnh</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="c in (myRow?.daily || [])" :key="`d-${c.day}`">
                    <tr :class="c.sunday ? 'table-secondary' : ''">
                      <td class="font-weight-bold">
                        {{ c.day }}
                        <div class="text-muted small" v-if="c.sunday">CN</div>
                      </td>
                      <td>
                        <span class="badge badge-pill" :class="statusBadge(c.status)">
                          {{ c.status || "-" }}
                        </span>
                        <span v-if="c.holiday" class="badge badge-pill badge-danger ml-2">Lễ</span>
                        <span v-if="c.coNghiPhep" class="badge badge-pill badge-info ml-2">Phép</span>
                      </td>
                      <td class="text-right font-weight-bold">{{ fmt(c.soCong) }}</td>
                      <td class="text-right">{{ fmt(c.soCongAm) }}</td>
                      <td class="text-right">{{ fmt(c.soCongPm) }}</td>
                      <td class="text-right">{{ fmt(c.tongVaoTre) }}</td>
                      <td class="text-right">{{ fmt(c.tongVaoSom) }}</td>
                      <td class="text-right">{{ fmt(c.tongRaSom) }}</td>
                      <td class="text-right">
                        <span v-if="c.tongQuenCham > 0" class="badge badge-danger">{{ c.tongQuenCham }}</span>
                        <span v-else class="text-muted">0</span>
                      </td>
                      <td class="text-right">{{ fmt(c.soLenhHoanThanh) }}</td>
                    </tr>

                    <!-- ✅ Desktop: dòng phụ hiển thị từng lệnh tăng ca/CN -->
                    <tr v-if="lenhByDay[dayKeyFromCell(c)]?.length" :key="`l-${c.day}`" class="lenh-row">
                      <td colspan="10" class="py-2">
                        <div class="d-flex flex-wrap" style="gap: 8px">
                          <div
                            v-for="l in lenhByDay[dayKeyFromCell(c)]"
                            :key="l.idLenh"
                            class="lenh-mini-item border rounded px-2 py-1"
                          >
                            <span
                              class="tag"
                              :class="l.loaiLenh === 'TANG_CA' ? 'tag-tc' : (l.loaiLenh === 'CHU_NHAT' ? 'tag-cn' : '')"
                            >
                              {{ l.loaiLenh === 'TANG_CA' ? 'TĂNG CA' : (l.loaiLenh === 'CHU_NHAT' ? 'CHỦ NHẬT' : 'LỆNH') }}
                            </span>
                            <span class="time">
                              {{ fmtTime(l.chamCong?.gioVao || l.batDau) }} → {{ fmtTime(l.chamCong?.gioRa || l.ketThuc) }}
                            </span>
                            <span class="text-muted">
                              • {{ Number(l.chamCong?.soGioThuong || 0).toFixed(2) }}h
                              • {{ fmtMoney(l.chamCong?.soTienThuong) }}đ
                              • #{{ l.idLenh }}
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>

                  <tr v-if="!(myRow?.daily || []).length">
                    <td colspan="10" class="text-center text-muted py-4">Không có dữ liệu lưới.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="card-footer small text-muted">
              Tổng công: <b class="text-dark">{{ fmt(gridTotalCong) }}</b> |
              Trễ: <b class="text-dark">{{ fmt(gridMinutesVaoTre) }}</b>p |
              Vào sớm: <b class="text-dark">{{ fmt(gridMinutesVaoSom) }}</b>p |
              Ra sớm: <b class="text-dark">{{ fmt(gridMinutesRaSom) }}</b>p |
              Quên: <b class="text-dark">{{ fmt(gridQuenCham) }}</b> |
              Lệnh: <b class="text-dark">{{ fmt(gridLenhHoanThanh) }}</b>
            </div>
          </div>
        </div>

        <!-- CONFIRM BAR -->
        <div class="card shadow-sm mt-3">
          <div class="card-body d-flex flex-wrap align-items-center justify-content-between">
            <div class="text-muted small">
              Bạn xác nhận công của {{ mmLabel }}. (Xác nhận xong vẫn chưa xem được lương nếu Admin chưa “gửi phiếu lương”.)
            </div>

            <div class="mt-2 mt-md-0">
              <button
                v-if="wf.congThangNay && !wf.userConfirmed"
                class="btn btn-success"
                @click="confirmMyCong"
                :disabled="loadingAny || wf.confirming"
              >
                <i class="fa fa-check mr-1"></i> Xác nhận công
              </button>

              <span v-else class="badge badge-success p-2">
                <i class="fa fa-check mr-1"></i> Đã xác nhận công
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- ====== TAB: OVERVIEW ====== -->
      <div v-if="canViewGrid" v-show="activeTab === 'overview'" class="mt-3">
        <!-- LOCK: chưa gửi phiếu lương -->
        <div v-if="!canViewSalary" class="card shadow-sm">
          <div class="card-body text-center py-5">
            <div class="mb-2">
              <i class="fa fa-lock text-muted" style="font-size: 42px"></i>
            </div>
            <div class="h5 mb-2">Chưa thể xem lương</div>
            <div class="text-muted mb-3">
              Điều kiện xem lương: <b>đã xác nhận công</b> + <b>Admin đã gửi phiếu lương</b>.
              Hiện tại: {{ wf.userConfirmed ? "✅ đã xác nhận công" : "❌ chưa xác nhận công" }},
              {{ wf.luongDaGui ? "✅ đã gửi phiếu lương" : "❌ chưa gửi phiếu lương" }}.
            </div>
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <button class="btn btn-outline-secondary" @click="reloadAll" :disabled="loadingAny">
                <i class="fa fa-refresh mr-1"></i> Tải lại
              </button>
              <button class="btn btn-outline-primary" @click="activeTab = 'grid'">
                <i class="fa fa-calendar mr-1"></i> Về lưới công
              </button>
            </div>
          </div>
        </div>

        <!-- SALARY VIEW -->
        <template v-else>
          <div class="row">
            <div class="col-md-3 col-6 mb-3">
              <div class="card shadow-sm h-100 kpi-card">
                <div class="card-body">
                  <div class="text-muted small">Thực nhận đến nay</div>
                  <div class="h4 mb-0">{{ formatMoney(netNow) }}</div>
                  <div class="text-muted small mt-1">asOf: {{ salary.asOf || "-" }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-6 mb-3">
              <div class="card shadow-sm h-100 kpi-card">
                <div class="card-body">
                  <div class="text-muted small">Dự kiến cuối tháng</div>
                  <div class="h4 mb-0">{{ formatMoney(netMonth) }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-6 mb-3">
              <div class="card shadow-sm h-100 kpi-card">
                <div class="card-body">
                  <div class="text-muted small">Trừ ứng lương (duyệt)</div>
                  <div class="h4 mb-0">{{ formatMoney(tamUngApproved) }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-6 mb-3">
              <div class="card shadow-sm h-100 kpi-card">
                <div class="card-body">
                  <div class="text-muted small">Tổng công (từ lưới)</div>
                  <div class="h4 mb-0">{{ fmt(gridTotalCong) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow-sm mb-3">
            <div class="card-header d-flex justify-content-between align-items-center">
              <div class="font-weight-bold">
                <i class="fa fa-list-alt text-warning mr-2"></i> Khoản lương (preview)
              </div>
              <div class="small text-muted">asOf: {{ salary.asOf || "-" }}</div>
            </div>

            <div v-if="salary.loading" class="p-3 text-muted">
              <i class="fa fa-spinner fa-spin mr-1"></i> Đang tải preview lương...
            </div>

            <div v-else class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Khoản</th>
                    <th>Loại</th>
                    <th>Cách tính</th>
                    <th class="text-right">Tháng</th>
                    <th class="text-right">Đến nay</th>
                    <th class="text-right">Ước tính</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="it in previewItemsWithTamUng" :key="it.idKhoangLuong">
                    <td>
                      <div class="font-weight-bold">{{ it.tenKhoang }}</div>
                      <div class="text-muted small">{{ it.maKhoang }}</div>
                      <div v-if="it._isTamUng" class="text-muted small">(chỉ tính khoản đã duyệt)</div>
                    </td>
                    <td>
                      <span class="badge badge-pill" :class="badgeLoai(it.loai)">{{ it.loai }}</span>
                    </td>
                    <td>{{ it.phuongThuc }}</td>
                    <td class="text-right">{{ formatMoney(it.giaTriThang) }}</td>
                    <td class="text-right font-weight-bold">{{ formatMoney(it.soTienDenNgay) }}</td>
                    <td class="text-right">{{ formatMoney(it.soTienUocTinhThang) }}</td>
                  </tr>

                  <tr v-if="!previewItemsWithTamUng.length">
                    <td colspan="6" class="text-center text-muted py-4">Không có khoản nào.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="d-flex flex-wrap gap-2">
            <button class="btn btn-danger" @click="activeTab = 'pdf'" :disabled="loadingAny">
              <i class="fa fa-file-pdf-o mr-1"></i> Sang tab PDF
            </button>
          </div>
        </template>
      </div>

      <!-- ====== TAB: PDF ====== -->
      <div v-if="canViewGrid" v-show="activeTab === 'pdf'" class="mt-3">
        <div v-if="!canViewSalary" class="card shadow-sm">
          <div class="card-body text-center py-5">
            <div class="mb-2">
              <i class="fa fa-lock text-muted" style="font-size: 42px"></i>
            </div>
            <div class="h5 mb-2">Chưa thể xuất PDF</div>
            <div class="text-muted mb-3">
              PDF gồm cả phiếu lương, nên cần: <b>đã xác nhận công</b> + <b>Admin đã gửi phiếu lương</b>.
            </div>
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <button class="btn btn-outline-secondary" @click="reloadAll" :disabled="loadingAny">
                <i class="fa fa-refresh mr-1"></i> Tải lại
              </button>
              <button class="btn btn-outline-primary" @click="activeTab = 'grid'">
                <i class="fa fa-calendar mr-1"></i> Về lưới công
              </button>
            </div>
          </div>
        </div>

        <div v-else class="card shadow-sm">
          <div class="card-body">
            <h5 class="mb-2"><i class="fa fa-file-pdf-o text-danger mr-2"></i>Xuất PDF</h5>
            <div class="text-muted small mb-3">PDF gồm: Phiếu công + Phiếu lương + Diễn giải thực nhận.</div>

            <div class="d-flex flex-wrap gap-2">
              <button class="btn btn-danger" @click="exportPdfReport" :disabled="loadingAny">
                <i class="fa fa-download mr-1"></i> Tải PDF
              </button>
              <button class="btn btn-outline-secondary" @click="reloadAll" :disabled="loadingAny">
                <i class="fa fa-refresh mr-1"></i> Làm mới dữ liệu
              </button>
            </div>

            <hr />

            <div class="small">
              <div><b>Tháng:</b> {{ mmLabel }}</div>
              <div><b>Nhân viên:</b> {{ myRow?.hoTen || "-" }} ({{ myRow?.phongBan || "-" }})</div>
              <div><b>Tổng công (lưới):</b> {{ fmt(gridTotalCong) }}</div>
              <div><b>Trễ:</b> {{ fmt(gridMinutesVaoTre) }}p | <b>Vào sớm:</b> {{ fmt(gridMinutesVaoSom) }}p</div>
              <div><b>Tổng lương đến nay:</b> {{ formatMoney(previewNowFromItems + tamUngApproved) }}</div>
              <div><b>Trừ ứng lương:</b> {{ formatMoney(tamUngApproved) }}</div>
              <div><b>Thực nhận đến nay:</b> {{ formatMoney(netNow) }}</div>
              <div><b>Dự kiến cuối tháng:</b> {{ formatMoney(netMonth) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MOBILE BOTTOM NAV -->
    <div class="mobile-bottom-nav d-md-none" v-if="canViewGrid">
      <button class="nav-btn" :class="{ active: activeTab === 'grid' }" @click="activeTab = 'grid'">
        <i class="fa fa-calendar"></i>
        <div class="lbl">Lưới công</div>
      </button>
      <button class="nav-btn" :class="{ active: activeTab === 'overview' }" @click="activeTab = 'overview'">
        <i class="fa fa-home"></i>
        <div class="lbl">Tổng quan</div>
      </button>
      <button class="nav-btn" :class="{ active: activeTab === 'pdf' }" @click="activeTab = 'pdf'">
        <i class="fa fa-file-pdf-o"></i>
        <div class="lbl">PDF</div>
      </button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Swal from "sweetalert2";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import wfService from "@/services/phieuCongLuongWorkflowService";

pdfMake.vfs = pdfFonts.vfs;
pdfMake.fonts = {
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

export default {
  name: "PhieuCongMy",

  data() {
    const now = new Date();
    return {
      now,
      activeTab: "grid",
      mm: { y: now.getFullYear(), m: now.getMonth() + 1, loading: false },

      myMonth: null,

      salary: { loading: false, data: null, asOf: null },

      tamUng: {
        loading: false,
        page: { number: 0, size: 10, totalPages: 1, totalElements: 0 },
        list: [],
      },

      // lệnh ACCEPTED (để fill tăng ca/CN nếu BE chưa trả items)
      lenh: { loading: false, list: [] },

      errMsg: null,
      companyLogo: null,

      wf: {
        loading: false,
        confirming: false,
        data: null,
        congThangNay: false,
        userConfirmed: false,
        luongDaGui: false,
      },
    };
  },

  computed: {
    monthInputValue() {
      const m = String(this.mm.m).padStart(2, "0");
      return `${this.mm.y}-${m}`;
    },
    mmLabel() {
      return `Tháng ${this.mm.m}/${this.mm.y}`;
    },
    myRow() {
      return this.myMonth?.rows?.[0] || null;
    },

    loadingAny() {
      return !!(
        this.mm.loading ||
        this.salary.loading ||
        this.tamUng.loading ||
        this.lenh.loading ||
        this.wf.loading ||
        this.wf.confirming
      );
    },

    // mở grid khi admin publish phiếu công
    canViewGrid() {
      return !!this.wf?.congThangNay;
    },

    // xem lương/PDF khi: đã confirm công + admin đã gửi phiếu lương
    canViewSalary() {
      return !!this.wf?.congThangNay && !!this.wf?.userConfirmed && !!this.wf?.luongDaGui;
    },

    // ===== tổng hợp từ month-grid response =====
    gridTotalCong() {
      return Number(this.myRow?.totalCong ?? this.myMonth?.totalCongAll ?? 0);
    },
    gridMinutesVaoTre() {
      return Number(this.myRow?.monthMinutesVaoTre ?? this.myMonth?.totalMinutesVaoTre ?? 0);
    },
    gridMinutesVaoSom() {
      return Number(this.myRow?.monthMinutesVaoSom ?? this.myMonth?.totalMinutesVaoSom ?? 0);
    },
    gridMinutesRaSom() {
      return Number(this.myRow?.monthMinutesRaSom ?? this.myMonth?.totalMinutesRaSom ?? 0);
    },
    gridQuenCham() {
      return Number(this.myRow?.monthQuenChamCount ?? this.myMonth?.totalQuenCham ?? 0);
    },
    gridNghiPhepFull() {
      return Number(this.myRow?.monthNghiPhepFull ?? this.myMonth?.totalNghiPhepFull ?? 0);
    },
    gridNghiPhepAm() {
      return Number(this.myRow?.monthNghiPhepAm ?? this.myMonth?.totalNghiPhepAm ?? 0);
    },
    gridNghiPhepPm() {
      return Number(this.myRow?.monthNghiPhepPm ?? this.myMonth?.totalNghiPhepPm ?? 0);
    },
    gridLenhHoanThanh() {
      return Number(this.myRow?.monthLenhHoanThanh ?? this.myMonth?.totalLenhHoanThanh ?? 0);
    },

    // ✅ map lệnh theo ngày: { "YYYY-MM-DD": [lenh...] }
    lenhByDay() {
      const map = {};
      const list = this.lenh?.list || [];

      for (const x of list) {
        const dt = x?.chamCong?.gioVao || x?.batDau;
        if (!dt) continue;

        const day = String(dt).slice(0, 10);
        if (!map[day]) map[day] = [];
        map[day].push(x);
      }

      Object.keys(map).forEach((k) => {
        map[k].sort((a, b) => {
          const ta = a?.chamCong?.gioVao || a?.batDau || "";
          const tb = b?.chamCong?.gioVao || b?.batDau || "";
          return ta.localeCompare(tb);
        });
      });

      return map;
    },

    // ===== Tam ứng theo tháng đang xem =====
    tamUngInSelectedMonth() {
      const y = this.mm.y,
        m = this.mm.m;
      return (this.tamUng.list || []).filter((x) => Number(x.nam) === Number(y) && Number(x.thang) === Number(m));
    },
    tamUngTotals() {
      const arr = this.tamUngInSelectedMonth || [];
      const out = { approved: 0, pending: 0, rejected: 0, cancelled: 0, total: 0 };
      for (const it of arr) {
        const st = String(it.trangThai || "").toUpperCase();
        const money = Number(it.soTien || 0);
        out.total += money;
        if (st === "APPROVED") out.approved += money;
        else if (st === "PENDING") out.pending += money;
        else if (st === "REJECTED") out.rejected += money;
        else if (st === "CANCELLED" || st === "CANCELED") out.cancelled += money;
      }
      return out;
    },
    tamUngApproved() {
      return Number(this.tamUngTotals.approved || 0);
    },

    // ===== ADD: thống kê lệnh theo tháng đang xem =====
    lenhStats() {
      return this.calcLenhStats(this.lenh.list || [], this.mm.y, this.mm.m);
    },

    // ===== Preview items + add tam ung + add tangca/chunhat nếu BE chưa trả =====
    tamUngRow() {
      const a = Number(this.tamUngApproved || 0);
      if (a <= 0) return null;
      return {
        idKhoangLuong: "TAMUNG_PREVIEW",
        maKhoang: "TAMUNG",
        tenKhoang: `Ứng lương (đã duyệt)`,
        loai: "KHAU_TRU",
        phuongThuc: "CO_DINH",
        giaTriThang: a,
        soTienDenNgay: a,
        soTienUocTinhThang: a,
        _isTamUng: true,
      };
    },

    previewItemsWithTamUng() {
      const items = (this.salary?.data?.items || []).slice();
      const upper = (s) => String(s || "").toUpperCase();

      const findMoneyFromBE = (maKhoang) => {
        const it = items.find((x) => upper(x.maKhoang) === upper(maKhoang));
        if (!it) return null;
        const v = it.soTienDenNgay != null ? it.soTienDenNgay : it.giaTriThang;
        if (v == null) return null;
        const n = Number(v || 0);
        return Number.isNaN(n) ? null : n;
      };

      const tangCaMoney = findMoneyFromBE("TANGCA") ?? Number(this.lenhStats?.tangCa?.soTien || 0);
      const chuNhatMoney = findMoneyFromBE("CHUNHAT") ?? Number(this.lenhStats?.chuNhat?.soTien || 0);

      const hasTangCa = items.some((x) => upper(x.maKhoang) === "TANGCA");
      const hasChuNhat = items.some((x) => upper(x.maKhoang) === "CHUNHAT");

      if (!hasTangCa && tangCaMoney > 0) {
        items.push({
          idKhoangLuong: "TANGCA_FE",
          maKhoang: "TANGCA",
          tenKhoang: "Tiền tăng ca",
          loai: "PHU_CAP",
          phuongThuc: "LENH",
          giaTriThang: tangCaMoney,
          soTienDenNgay: tangCaMoney,
          soTienUocTinhThang: tangCaMoney,
          _isLenhIncome: true,
        });
      }

      if (!hasChuNhat && chuNhatMoney > 0) {
        items.push({
          idKhoangLuong: "CHUNHAT_FE",
          maKhoang: "CHUNHAT",
          tenKhoang: "Tiền làm chủ nhật",
          loai: "PHU_CAP",
          phuongThuc: "LENH",
          giaTriThang: chuNhatMoney,
          soTienDenNgay: chuNhatMoney,
          soTienUocTinhThang: chuNhatMoney,
          _isLenhIncome: true,
        });
      }

      if (this.tamUngRow) items.push(this.tamUngRow);
      return items;
    },

    previewNowFromItems() {
      const items = this.previewItemsWithTamUng || [];
      let total = 0;

      for (const it of items) {
        const loai = String(it.loai || "").toUpperCase();
        const v = Number(it.soTienDenNgay ?? 0);
        if (Number.isNaN(v)) continue;

        if (loai === "CO_BAN" || loai === "PHU_CAP") total += v;
        if (loai === "KHAU_TRU") total -= v;
      }
      return Math.max(0, total);
    },

    netNow() {
      return this.previewNowFromItems;
    },

    previewMonth() {
      return Number(this.salary?.data?.duKienCuoiThang || 0);
    },

    netMonth() {
      return Math.max(0, this.previewMonth - this.tamUngApproved);
    },
  },

  mounted() {
    this.reloadAll();
  },

  methods: {
    // ✅ key ngày cho cell từ monthInputValue + c.day (fix scope + fix month undefined)
    dayKeyFromCell(c) {
      const ym = this.monthInputValue; // "YYYY-MM"
      const dd = String(c?.day ?? "").padStart(2, "0");
      if (!ym || !dd || dd === "00") return null;
      return `${ym}-${dd}`; // "YYYY-MM-DD"
    },

    async reloadAll() {
      this.errMsg = null;

      // 1) workflow trước
      await this.fetchWorkflowMy();

      // 2) nếu chưa publish phiếu công: khoá grid
      if (!this.canViewGrid) {
        this.myMonth = null;
        this.salary.data = null;

        await Promise.allSettled([this.fetchMyTamUng(0)]);
        this.activeTab = "overview";
        return;
      }

      // 3) đã publish phiếu công: load grid + tạm ứng + lệnh
      await Promise.allSettled([this.fetchMyMonthGrid(), this.fetchMyTamUng(0), this.fetchMyLenhAccepted()]);

      // 4) chỉ load lương khi canViewSalary (đã gửi phiếu lương)
      if (this.canViewSalary) {
        await this.fetchSalaryPreview();
      } else {
        this.salary.data = null;
      }

      // 5) ưu tiên hiển thị grid
      this.activeTab = "grid";
    },

    async fetchWorkflowMy() {
      this.wf.loading = true;
      try {
        const month = this.monthInputValue;
        const { data } = await wfService.my(month);

        const dto = data || null;
        this.wf.data = dto;
        this.wf.congThangNay = !!dto?.congThangNay;
        this.wf.userConfirmed = !!dto?.userConfirmed;
        this.wf.luongDaGui = !!dto?.luongDaGui;
      } catch (e) {
        this.wf.data = null;
        this.wf.congThangNay = false;
        this.wf.userConfirmed = false;
        this.wf.luongDaGui = false;
        this.errMsg = this.errMsg || e?.response?.data?.message || e?.message || "Không tải được trạng thái phiếu";
      } finally {
        this.wf.loading = false;
      }
    },

    async confirmMyCong() {
      if (!this.wf.congThangNay) return;

      const ok = await Swal.fire({
        title: "Xác nhận phiếu công?",
        text: "Bạn xác nhận công tháng này là đúng.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
      });
      if (!ok.isConfirmed) return;

      this.wf.confirming = true;
      try {
        const month = this.monthInputValue;
        await wfService.confirmCong(month);
        await Swal.fire("Thành công", "Bạn đã xác nhận phiếu công.", "success");

        await this.fetchWorkflowMy();

        if (this.canViewSalary) {
          await Promise.allSettled([this.fetchSalaryPreview(), this.fetchMyLenhAccepted()]);
          this.activeTab = "overview";
        } else {
          this.activeTab = "grid";
        }
      } catch (e) {
        Swal.fire("Lỗi", e?.response?.data?.message || e?.message || "Không xác nhận được", "error");
      } finally {
        this.wf.confirming = false;
      }
    },

    // ======== đúng endpoint bạn yêu cầu =========
    async fetchMyMonthGrid() {
      this.mm.loading = true;
      try {
        const month = this.monthInputValue; // "YYYY-MM"
        const { data } = await api.get("/api/cham-cong/my/month-grid", { params: { month } });
        this.myMonth = data?.data || null;
      } catch (e) {
        this.myMonth = null;
        this.errMsg = e?.response?.data?.message || e?.message || "Không tải được lưới tháng";
      } finally {
        this.mm.loading = false;
      }
    },

    async fetchSalaryPreview() {
      this.salary.loading = true;
      try {
        const ym = this.monthInputValue;
        const asOf = this.monthEndStr(this.mm.y, this.mm.m);
        this.salary.asOf = asOf;

        const { data } = await api.get("/api/payroll/my/preview", { params: { month: ym, asOf } });
        this.salary.data = data?.data || null;
      } catch (e) {
        this.salary.data = null;
        this.errMsg = this.errMsg || e?.response?.data?.message || e?.message || "Không tải được preview lương";
      } finally {
        this.salary.loading = false;
      }
    },

    async fetchMyTamUng(page = 0) {
      this.tamUng.loading = true;
      try {
        const { data } = await api.get("/api/tam-ung-luong/my", {
          params: { page, size: this.tamUng.page.size },
        });
        const pg = data || { content: [], number: 0, size: 10, totalPages: 1, totalElements: 0 };
        this.tamUng.list = pg.content || [];
        this.tamUng.page.number = pg.number ?? 0;
        this.tamUng.page.size = pg.size ?? this.tamUng.page.size;
        this.tamUng.page.totalPages = pg.totalPages ?? 1;
        this.tamUng.page.totalElements = pg.totalElements ?? (pg.content?.length || 0);
      } catch {
        this.tamUng.list = [];
        this.tamUng.page.totalPages = 1;
        this.tamUng.page.totalElements = 0;
      } finally {
        this.tamUng.loading = false;
      }
    },

    // ===== ADD: fetch lệnh ACCEPTED =====
    async fetchMyLenhAccepted() {
      this.lenh.loading = true;
      try {
        const { data } = await api.get("/api/lenh/my", { params: { status: "ACCEPTED" } });
        this.lenh.list = data?.data || [];
      } catch {
        this.lenh.list = [];
      } finally {
        this.lenh.loading = false;
      }
    },

    fmtTime(dt) {
      if (!dt) return "";
      return String(dt).slice(11, 16);
    },
    fmtMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString("vi-VN");
    },
    lenhLabel(loai) {
      if (loai === "TANG_CA") return "Tăng ca";
      if (loai === "CHU_NHAT") return "Chủ nhật";
      return loai || "Lệnh";
    },
    lenhBadgeClass(loai) {
      if (loai === "TANG_CA") return "badge badge-info";
      if (loai === "CHU_NHAT") return "badge badge-warning";
      return "badge badge-secondary";
    },

    onPickMonth(e) {
      try {
        const v = e?.target?.value;
        if (!v || !/^\d{4}-\d{2}$/.test(v)) return;
        this.mm.y = Number(v.slice(0, 4));
        this.mm.m = Number(v.slice(5, 7));
        this.reloadAll();
      } catch {}
    },

    prevMonth() {
      let y = this.mm.y,
        m = this.mm.m - 1;
      if (m < 1) {
        m = 12;
        y--;
      }
      this.mm.y = y;
      this.mm.m = m;
      this.reloadAll();
    },

    nextMonth() {
      let y = this.mm.y,
        m = this.mm.m + 1;
      if (m > 12) {
        m = 1;
        y++;
      }
      this.mm.y = y;
      this.mm.m = m;
      this.reloadAll();
    },

    fmt(v) {
      if (v === null || v === undefined) return "0";
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return n.toLocaleString("vi-VN");
    },

    formatMoney(v) {
      if (v === null || v === undefined) return "0 đ";
      const n = Number(v);
      if (Number.isNaN(n)) return `${v} đ`;
      return n.toLocaleString("vi-VN") + " đ";
    },

    badgeLoai(loai) {
      const x = String(loai || "").toUpperCase();
      if (x === "KHAU_TRU") return "badge-danger";
      if (x === "PHU_CAP") return "badge-info";
      if (x === "CO_BAN") return "badge-success";
      return "badge-secondary";
    },

    statusBadge(s) {
      const x = String(s || "").toUpperCase();
      if (x === "FULL") return "badge-success";
      if (x === "HALF_AM" || x === "HALF_PM") return "badge-warning";
      if (x === "ABSENT") return "badge-secondary";
      if (x.includes("OPEN")) return "badge-danger";
      return "badge-info";
    },

    congText(v, buoiLabel) {
      const n = Number(v || 0);
      if (n >= 1) return "Đủ công";
      if (n === 0.5) return `Nửa công${buoiLabel ? " (" + buoiLabel + ")" : ""}`;
      return "Không";
    },

    statusText(s) {
      const x = String(s || "").toUpperCase();
      if (x === "FULL") return "Đủ công";
      if (x === "HALF_AM") return "Nửa công (Sáng)";
      if (x === "HALF_PM") return "Nửa công (Chiều)";
      if (x === "ABSENT") return "Vắng";
      if (x.includes("OPEN")) return "Chưa chốt";
      return s || "-";
    },

    toLocalYmd(d) {
      const yy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yy}-${mm}-${dd}`;
    },

    monthEndStr(y, m) {
      const last = new Date(y, m, 0);
      return this.toLocalYmd(last);
    },

    // ===== ADD: helpers thống kê lệnh =====
    ymd(d) {
      const x = new Date(d);
      if (Number.isNaN(x.getTime())) return null;
      const yy = x.getFullYear();
      const mm = String(x.getMonth() + 1).padStart(2, "0");
      const dd = String(x.getDate()).padStart(2, "0");
      return `${yy}-${mm}-${dd}`;
    },

    inMonth(dt, y, m) {
      const x = new Date(dt);
      if (Number.isNaN(x.getTime())) return false;
      return x.getFullYear() === Number(y) && x.getMonth() + 1 === Number(m);
    },

    pickLenhTime(it) {
      return it?.batDau || it?.ketThuc || it?.createdAt || it?.ngayTao || it?.updatedAt || null;
    },

    calcLenhStats(list, y, m) {
      const out = {
        tangCa: { soLan: 0, soGio: 0, soTien: 0 },
        chuNhat: { soNgay: 0, soGio: 0, soTien: 0 },
      };

      const sundayDays = new Set();

      for (const it of list || []) {
        const timeKey = this.pickLenhTime(it);
        if (!timeKey || !this.inMonth(timeKey, y, m)) continue;

        const cc = it?.chamCong;
        if (!cc) continue;

        const loai = String(it?.loaiLenh || it?.loai || "").toUpperCase();
        const gio = Number(cc?.soGioThuong || cc?.soGio || 0);
        const tien = Number(cc?.soTienThuong || cc?.soTien || 0);

        if (loai === "TANG_CA" || loai === "TANGCA") {
          out.tangCa.soLan += 1;
          out.tangCa.soGio += gio;
          out.tangCa.soTien += tien;
        } else if (loai === "CHU_NHAT" || loai === "CHUNHAT") {
          const day = this.ymd(timeKey);
          if (day) sundayDays.add(day);
          out.chuNhat.soGio += gio;
          out.chuNhat.soTien += tien;
        }
      }

      out.chuNhat.soNgay = sundayDays.size;

      out.tangCa.soGio = Math.round(out.tangCa.soGio * 100) / 100;
      out.chuNhat.soGio = Math.round(out.chuNhat.soGio * 100) / 100;

      out.tangCa.soTien = Math.round(out.tangCa.soTien);
      out.chuNhat.soTien = Math.round(out.chuNhat.soTien);

      return out;
    },

    // ===================== PDF FULL =====================
    async exportPdfReport() {
      try {
        if (!this.canViewSalary) {
          await Swal.fire("Chưa đủ điều kiện", "Cần: Bạn đã xác nhận công + Admin đã gửi phiếu lương.", "warning");
          return;
        }

        if (!this.companyLogo) {
          await this.loadCompanyLogo();
        }

        const docDefinition = this.buildPdfPayslipDocDefinition();
        const fileName = this.buildPdfFileName();
        pdfMake.createPdf(docDefinition).download(fileName);
      } catch (e) {
        console.error(e);
        Swal.fire({
          icon: "error",
          title: "Xuất PDF thất bại",
          text: e?.message || "Không thể tạo báo cáo PDF",
        });
      }
    },

    buildPdfPayslipDocDefinition() {
      const now = new Date();
      const nowStr = now.toLocaleString("vi-VN", { hour12: false });

      const employeeName = this.myRow?.hoTen || this.salary?.data?.hoTen || "—";
      const chucDanh = this.myRow?.chucDanh || this.myRow?.vaiTro || "—";
      const maNv = this.myRow?.maNhanVien || this.myRow?.maNV || this.myRow?.username || "—";

      const ngayCongThucTe = Number(this.salary?.data?.ngayThucTeDenNgay ?? this.salary?.data?.ngayThucTe ?? 0);
      const ngayCongChuan = Number(this.salary?.data?.ngayChuanCty ?? 0);

      const s = this.lenhStats || { tangCa: {}, chuNhat: {} };
      const tc = s.tangCa || { soLan: 0, soGio: 0, soTien: 0 };
      const cn = s.chuNhat || { soNgay: 0, soGio: 0, soTien: 0 };

      const rawItems = (this.salary?.data?.items || []).map((x) => ({
        ten: x.tenKhoang || "",
        ma: x.maKhoang || "",
        loai: String(x.loai || "").toUpperCase(),
        month: Number(x.soTienDenNgay ?? x.tamTinhDenNgay ?? x.giaTriThang ?? 0),
      }));

      let incomes = rawItems.filter((x) => x.loai === "CO_BAN" || x.loai === "PHU_CAP");
      const deductions = rawItems.filter((x) => x.loai === "KHAU_TRU").slice();

      const upper = (s) => String(s || "").toUpperCase();
      const hasTangCa = rawItems.some((x) => upper(x.ma) === "TANGCA");
      const hasChuNhat = rawItems.some((x) => upper(x.ma) === "CHUNHAT");

      const tcMoney = Number(tc.soTien || 0);
      const cnMoney = Number(cn.soTien || 0);

      if (!hasTangCa && tcMoney > 0) {
        incomes.push({ ten: "Tiền tăng ca", ma: "TANGCA", loai: "PHU_CAP", month: tcMoney, _isLenhIncome: true });
      }
      if (!hasChuNhat && cnMoney > 0) {
        incomes.push({ ten: "Tiền làm chủ nhật", ma: "CHUNHAT", loai: "PHU_CAP", month: cnMoney, _isLenhIncome: true });
      }

      const tamUng = Number(this.tamUngApproved || 0);
      if (tamUng > 0) {
        deductions.push({ ten: "Tạm Ứng", ma: "TAMUNG", loai: "KHAU_TRU", month: tamUng, _isTamUng: true });
      }

      const sum = (arr) => arr.reduce((s, x) => s + Number(x.month || 0), 0);
      const totalIncome = sum(incomes);
      const totalDeduction = sum(deductions);
      const netPay = Math.max(0, totalIncome - totalDeduction);

      const monthTitle = `Tháng ${String(this.mm.m).padStart(2, "0")} năm ${this.mm.y}`;
      const endYmd = this.monthEndStr(this.mm.y, this.mm.m);
      const dateLine = `Ngày ${String(endYmd).slice(8, 10)} tháng ${String(this.mm.m).padStart(2, "0")} năm ${this.mm.y}`;

      const leftInfoTable = this.pdfBoxTable([
        ["Mã Nhân Viên", maNv],
        ["Họ Và Tên", { text: employeeName, color: "#c00000", bold: true }],
        ["Chức Danh", chucDanh],
      ]);

      const rightInfoTable = this.pdfBoxTable([
        ["Lương đóng BHXH", this.formatMoney(Number(this.salary?.data?.luongDongBhxh ?? 0))],
        ["Ngày công đi làm", String(ngayCongThucTe || 0)],
        ["Ngày công chuẩn", String(ngayCongChuan || 0)],
        ["Số lần tăng ca", String(tc.soLan || 0)],
        ["Số giờ tăng ca", String(tc.soGio || 0)],
        ["Số lần CN", String(cn.soNgay || 0)],
        ["Số giờ CN", String(cn.soGio || 0)],
      ]);

      const incomeTable = this.pdfMoneyTable("Các Khoản Thu Nhập", incomes, totalIncome);
      const deductionTable = this.pdfMoneyTable("Các Khoản Trừ Vào Lương", deductions, totalDeduction);

      const headerBlock = this.companyLogo
        ? {
            columns: [
              { width: 70, image: this.companyLogo, fit: [60, 60], margin: [0, 0, 8, 0] },
              {
                width: "*",
                stack: [
                  { text: "CÔNG TY TNHH XNK THÉP & THIẾT BỊ CÔNG NGHIỆP MINH TIẾN", style: "company" },
                  { text: "Địa chỉ: 1097 Huỳnh Văn Lũy, Phú Mỹ, Thủ Dầu Một, Bình Dương", style: "address" },
                ],
              },
            ],
            margin: [0, 0, 0, 6],
          }
        : [
            { text: "CÔNG TY TNHH XNK THÉP & THIẾT BỊ CÔNG NGHIỆP MINH TIẾN", style: "company" },
            { text: "Địa chỉ: 1097 Huỳnh Văn Lũy, Phú Mỹ, Thủ Dầu Một, Bình Dương", style: "address" },
          ];

      return {
        pageSize: "A4",
        pageMargins: [24, 18, 24, 18],
        defaultStyle: { font: "Roboto", fontSize: 10 },
        styles: {
          company: { fontSize: 16, bold: true, alignment: "center" },
          address: { fontSize: 10, alignment: "center", margin: [0, 4, 0, 10] },
          title: { fontSize: 20, bold: true, color: "#c00000", alignment: "center", margin: [0, 2, 0, 2] },
          subtitle: { fontSize: 14, bold: true, color: "#1f4e79", alignment: "center", margin: [0, 0, 0, 10] },
          th: { fillColor: "#d9d9d9", bold: true, alignment: "center" },
          netBox: { fontSize: 14, bold: true, alignment: "center" },
          sign: { bold: true, alignment: "center" },
          small: { fontSize: 9, color: "#666" },
        },
        content: [
          ...(Array.isArray(headerBlock) ? headerBlock : [headerBlock]),
          { text: "Phiếu Thanh Toán Tiền Lương", style: "title" },
          { text: monthTitle, style: "subtitle" },
          {
            columns: [
              { width: "*", margin: [0, 0, 12, 0], ...leftInfoTable },
              { width: "*", margin: [12, 0, 0, 0], ...rightInfoTable },
            ],
          },
          { text: " ", margin: [0, 6, 0, 0] },
          {
            columns: [
              { width: "*", margin: [0, 0, 12, 0], ...incomeTable },
              { width: "*", margin: [12, 0, 0, 0], ...deductionTable },
            ],
          },
          { text: " ", margin: [0, 10, 0, 0] },
          {
            table: {
              widths: ["*", 180],
              body: [[
                { text: "Tổng Số Tiền Lương Thực Nhận", style: "netBox" },
                { text: this.formatMoney(netPay), style: "netBox" },
              ]],
            },
            layout: {
              hLineWidth: () => 1,
              vLineWidth: () => 1,
              paddingLeft: () => 8,
              paddingRight: () => 8,
              paddingTop: () => 6,
              paddingBottom: () => 6,
            },
          },
          { text: dateLine, alignment: "right", margin: [0, 12, 0, 12] },
          {
            columns: [
              { width: "*", text: "Người lập phiếu", style: "sign" },
              { width: "*", text: "Người nhận tiền", style: "sign" },
              { width: "*", text: "Thủ Quỹ", style: "sign" },
              { width: "*", text: "Giám Đốc", style: "sign" },
            ],
          },
          { text: `In lúc: ${nowStr}`, style: "small", margin: [0, 18, 0, 0], alignment: "right" },
        ],
      };
    },

    async loadCompanyLogo() {
      try {
        const url = "https://pm.thepminhtien.com/assets/img/logominhtien.png";
        this.companyLogo = await this.toDataUrl(url);
      } catch (e) {
        this.companyLogo = null;
        console.warn("Không tải được logo:", e?.message || e);
      }
    },

    async toDataUrl(url) {
      const res = await fetch(url, { cache: "no-store" });
      if (!res.ok) throw new Error(`HTTP ${res.status} when fetching logo`);
      const blob = await res.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },

    pdfBoxTable(rows) {
      return {
        table: {
          widths: [120, "*"],
          body: rows.map((r) => ([
            { text: r[0], bold: true },
            typeof r[1] === "object" ? r[1] : { text: String(r[1] ?? "") },
          ])),
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          paddingLeft: () => 6,
          paddingRight: () => 6,
          paddingTop: () => 5,
          paddingBottom: () => 5,
        },
      };
    },

    pdfMoneyTable(title, items, total) {
      const body = [
        [{ text: "STT", style: "th" }, { text: title, style: "th" }, { text: "Số Tiền", style: "th" }],
      ];

      if (!items.length) {
        body.push([{ text: "Không có dữ liệu", colSpan: 3, alignment: "center", italics: true, color: "#666", margin: [0, 6, 0, 6] }, {}, {}]);
      } else {
        items.forEach((it, idx) => {
          body.push([
            { text: String(idx + 1), alignment: "center" },
            { text: it.ten || it.ma || "-" },
            { text: this.formatMoney(it.month || 0), alignment: "right", bold: !!it._isTamUng || !!it._isLenhIncome },
          ]);
        });
      }

      body.push([
        { text: "", border: [true, false, true, true] },
        { text: "Tổng Cộng", bold: true, alignment: "center" },
        { text: this.formatMoney(total), alignment: "right", bold: true },
      ]);

      return {
        table: { widths: [38, "*", 110], body },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          paddingLeft: () => 6,
          paddingRight: () => 6,
          paddingTop: () => 5,
          paddingBottom: () => 5,
        },
      };
    },

    buildPdfFileName() {
      const ym = `${this.mm.y}-${String(this.mm.m).padStart(2, "0")}`;
      const rawName = (this.myRow?.hoTen || "nhan_vien")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
        .toLowerCase();
      return `Phieu_cong_va_luong_${rawName || "nhan_vien"}_${ym}.pdf`;
    },
  },
};
</script>

<style scoped>
.phieucong-page {
  background: #f7f8fb;
}

.mobile-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #fff;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.pb-mobile-nav {
  padding-bottom: 82px;
}

.mobile-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 30;
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  padding: 8px 8px 10px;
  gap: 8px;
}

.nav-btn {
  flex: 1;
  border: none;
  background: transparent;
  padding: 8px 6px;
  border-radius: 12px;
  color: #6c757d;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nav-btn i {
  font-size: 18px;
  margin-bottom: 4px;
}

.nav-btn .lbl {
  font-size: 11px;
  line-height: 1;
}

.nav-btn.active {
  background: rgba(0, 123, 255, 0.1);
  color: #007bff;
}

.kpi-card .h4 {
  font-weight: 800;
}

.day-card {
  background: #fff;
}

.day-card--sun {
  background: #f1f3f5;
}

.day-card--holiday {
  border-color: rgba(220, 53, 69, 0.35) !important;
}

.day-card--leave {
  border-color: rgba(23, 162, 184, 0.35) !important;
}

.gap-2 {
  gap: 8px;
}

.lenh-line {
  background: #fff;
}

.lenh-mini-item {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 11px;
}

.lenh-mini-item .tag {
  padding: 1px 6px;
  border-radius: 10px;
  color: #fff;
  font-weight: 600;
}

.lenh-mini-item .tag-tc {
  background: #17a2b8;
} /* info */
.lenh-mini-item .tag-cn {
  background: #f0ad4e;
} /* warning */
.lenh-mini-item .time {
  color: #555;
}

.lenh-row td {
  background: #fcfcfd;
}
</style>
